import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncomeAndAssetsSteps } from '../../../../../../enums/income-and-assets-steps.enum';
import { StepSection } from '../../../../../../enums/step-section.enum';
import { PropertySteps } from '../../../../../../enums/property-steps.enum';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';
import { CitizenshipOptions } from '../../../about-you/steps/borrower-citizenship/borrower-citizenship.component';
import { GettingStartedSteps } from '../../../../../../enums/getting-started-steps.enum';
import { PropertyUsageOptions } from '../../../property/steps/property-usage/property-usage.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

export enum InvestmentRentalIncomeOptions {
  Yes = 'Yes',
  No = 'No'
}

@Component({
  selector: 'lgv-investment-rental-income',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule,
    MatButtonModule
  ],
  templateUrl: './investment-rental-income.component.html',
  styleUrls: ['./investment-rental-income.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentRentalIncomeComponent {
  InvestmentRentalIncomeOptions = InvestmentRentalIncomeOptions
  isDialog = this.contextService.isDialog
  optionSelected = this.answerService.getAnswer(IncomeAndAssetsSteps.InvestmentRentalIncome) ?? ''
  isPurchase = this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) === 'Purchase' ? true : false

  @Output() stepChange = new EventEmitter<any>();
  @Output() sectionChange = new EventEmitter<any>();

  private yesTasks: string[] = this.assignTasks();

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService,
  ) { }

  ngOnInit(): void {
    this.syncTasksWithAnswer(this.optionSelected);
  }

  onAnswerSelected(ans: string) {
    this.optionSelected = ans
  }

  onNext() {
    this.answerService.setAnswer(IncomeAndAssetsSteps.InvestmentRentalIncome, this.optionSelected)
    this.clearAllTasks();
    this.syncTasksWithAnswer(this.optionSelected);
    if (this.answerService.getAnswer(IncomeAndAssetsSteps.InvestmentRentalIncome) === InvestmentRentalIncomeOptions.No){
      this.answerService.setAnswer(IncomeAndAssetsSteps.InvestmentExtraIncome, '')
    }
    this.answerService.getAnswer(IncomeAndAssetsSteps.InvestmentRentalIncome) === InvestmentRentalIncomeOptions.Yes 
      ? this.goToStep(IncomeAndAssetsSteps.InvestmentExtraIncome) : this.goToStep(IncomeAndAssetsSteps.IncomeSource)
  }

  onBack() {
    this.answerService.setAnswer(IncomeAndAssetsSteps.InvestmentRentalIncome, this.optionSelected)
    this.clearAllTasks();
    this.goToSection(StepSection.Property, PropertySteps.PropertyUsage);
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  goToSection(section, step) {
    this.sectionChange.emit([section, step]);
  }

  isBtnSelected(option: string) {
    if (option === this.optionSelected) {
      return true
    }
  }

  isNextDisabled(): boolean {
    if (this.optionSelected === '') {
      return true
    }
    return false
  }

  private clearAllTasks(): void {
    [...this.yesTasks,]
      .forEach(task => this.taskService.removeTask(task));
  }

  private syncTasksWithAnswer(answer: string): void {
    switch (answer) {
      case InvestmentRentalIncomeOptions.Yes:
        this.yesTasks.forEach(task => this.taskService.addTask(task));
        break;
    }
  }

  assignTasks(): string[] {
    let taskList = []
    if (this.isPurchase && this.answerService.getAnswer(PropertySteps.PropertyUsage) === PropertyUsageOptions.Investment) {
      taskList.push("Homeowner's Insurance")
      taskList.push("Lease Agreement(s)")
      taskList.push("Saving - Bank Statements")
      taskList.push("Checking - Bank Statements")
    }
    return taskList
  }

}
